import { render, staticRenderFns } from "./Specialist.vue?vue&type=template&id=445e3aa6&scoped=true&"
import script from "@/views/Users/Specialist/Specialist.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Specialist/Specialist.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Specialist/specialist.scss?vue&type=style&index=0&id=445e3aa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e3aa6",
  null
  
)

export default component.exports